
export default {
  data() {
    return {
    }
  },
  methods: {
    // 支付图标
    supportPayIcon(paymentType) {
      let pay_icon = require("@/assets/imgs/icon_creditcard.png")
      // 支持传入完整 item 对象（含 subType）
      let p_type = (typeof paymentType === 'object' ? paymentType.pPaymentType : paymentType) || ''
      let subType = (typeof paymentType === 'object' ? paymentType.subType : '') || ''
      p_type = p_type.toLocaleUpperCase()
      if (p_type.includes("GOOGLE")) {
        pay_icon = require("@/assets/imgs/icon_googlepay.png")
      } else if (p_type.includes("APPLE")) {
        pay_icon = require("@/assets/imgs/icon_applepay.png")
      } else if (p_type.includes("PAYPAL")) {
        pay_icon = require("@/assets/imgs/icon_paypal.png")
      } else if (p_type.includes("AYA")) {
        pay_icon = require("@/assets/imgs/icon_pay.png")
      } else if (p_type === "MERCADOPAGO" && subType === "CheckoutPro") {
        pay_icon = require("@/assets/imgs/icon_mercadopago.png")
      }

      return pay_icon;
    },
    /**
     * 支持的支付类型适配
     * @param [{pPaymentType}] model
     */
    supportPayMode(model) {
      let payModel = model.map((v = {}) => {
        const pPaymentType = v.pPaymentType;
        // MercadoPago Card Form 传完整对象以便 supportPayIcon 识别 subType
        v.pay_icon = this.supportPayIcon(pPaymentType === "MercadoPago" ? v : pPaymentType)
        if (pPaymentType === "STRIPE_CARD") {
          v.label = "Credit Card"
          v.phone = "all"
        } else if (
          pPaymentType === "STRIPE_WECHAT" ||
          pPaymentType === "WeChat_MP"
        ) {
          v.label = "WeChat"
          v.phone = "wechat"
        } else if (pPaymentType === "PAYPAL") {
          v.label = "PayPal"
          v.phone = "all"
        } else if (
          (pPaymentType === "APPLE_PAY" ||
            pPaymentType === "STRIPE_APPLE") && this.system === 'ios'
        ) {
          v.label = "Apple Pay"
          v.phone = "ios"
        } else if (
          (pPaymentType === "GOOGLE_PAY" ||
            pPaymentType === "STRIPE_GOOGLE")
        ) {
          v.label = "Google Pay"
          v.phone = "android"
        } else if (pPaymentType === "M-PESA") {
          v.label = "SMS Payment"
          v.phone = "all"
        } else if (pPaymentType === "STRIPE_IDAEL" ||
          pPaymentType === "STRIPE_IDEAL") {
          v.label = "Idael Pay"
          v.phone = "all"
        } else if (pPaymentType === "MercadoPago") {
          v.label = "Credit Card"
          v.phone = "all"
        } else if (pPaymentType === "Flutterwave_Mobile") {
          v.label = "Credit Card"
          v.phone = "all"
        } else if (pPaymentType === "SumUpOnlinePayment") {
          v.label = "Credit Card"
          v.phone = "all"
        } else if (pPaymentType === "Espees") {
          v.label = "Credit Card"
          v.phone = "all"
        } else if (pPaymentType === "Aya_Pay") {
          v.label = "Aya Pay"
          v.phone = "all"
        } else {
          v.label = "Unknow"
          v.phone = "null"
        }
        return v
      })
      payModel = payModel.filter((v) => {
        return v.label !== "Unknow";
      })
      // MercadoPago 双入口:追加 Checkout Pro 入口
      const mpIndex = payModel.findIndex(v => v.pPaymentType === "MercadoPago");
      if (mpIndex !== -1) {
        const checkout = JSON.parse(JSON.stringify(payModel[mpIndex]));
        checkout.label = "Mercado Pago";
        checkout.subType = "CheckoutPro";
        checkout.pay_icon = this.supportPayIcon(checkout);
        payModel.splice(mpIndex, 0, checkout);
      }
      return payModel
    },
  }
}
